import { Currency } from '../constants/currency';
import { configurationService } from './configuration-service';

class CurrencyService {
  /**
   * Format price according to current currency configuration
   */
  public formatPrice(amount: number, currency?: Currency): string {
    const currentCurrency = currency || configurationService.getCurrency();
    
    switch (currentCurrency) {
      case Currency.EGP:
        return `${amount.toFixed(0)} EGP`;
      case Currency.USD:
        return `$${amount.toFixed(2)}`;
      case Currency.EUR:
        return `€${amount.toFixed(2)}`;
      case Currency.GBP:
        return `£${amount.toFixed(2)}`;
      default:
        return `${amount.toFixed(0)} EGP`;
    }
  }

  /**
   * Get currency symbol
   */
  public getCurrencySymbol(currency?: Currency): string {
    const currentCurrency = currency || configurationService.getCurrency();
    
    switch (currentCurrency) {
      case Currency.EGP:
        return 'EGP';
      case Currency.USD:
        return '$';
      case Currency.EUR:
        return '€';
      case Currency.GBP:
        return '£';
      default:
        return 'EGP';
    }
  }

  /**
   * Format price with currency label (alias for formatPrice for consistency)
   */
  public formatPriceWithCurrency(amount: number, currency?: Currency): string {
    return this.formatPrice(amount, currency);
  }

  /**
   * Convert price between currencies (placeholder for future implementation)
   */
  public convertPrice(amount: number, fromCurrency: Currency, toCurrency: Currency): number {
    // Placeholder - would integrate with currency conversion API in the future
    if (fromCurrency === toCurrency) {
      return amount;
    }
    
    // For now, just return the same amount
    // TODO: Implement actual currency conversion
    return amount;
  }
}

export const currencyService = new CurrencyService();